<div *ngIf="report">

    <div [style]="styles.header.page">
        <div [style]="styles.header.text"><b>AREAS OF IMPROVEMENT</b></div>
    
        <div [style]="styles.header.line"></div>
      </div>
    
    
      <div [style]="styles.container_padding">
    
          <h2 [style]="styles.general_h2"><b>Your Least Developed Coaching Style</b></h2>
    
          <p [style]="styles.paragraph">The least used coaching style is the 
            <span [style]="styles.highlight"> {{ report.leastDevCoachingStyle }}</span>.</p>
    
          <p [style]="styles.paragraph" [innerHtml]="html"></p>

</div>
